import axios from 'axios';

export default class ServicioGrupoEtapaService {

    getServicioGrupoEtapa(info) {            
        const url = process.env.VUE_APP_APIURL + `/api/serviciogrupoetapa`;    
        return axios.post(url,info,{headers:{"Content-Type" : "application/json"}}).then(res=>res.data);
    }

  
    createServicioGrupoEtapa(info){
        const url = process.env.VUE_APP_APIURL + `/api/serviciogrupoetapaalta`;     
        return axios.post(url,info,{headers:{"Content-Type" : "application/json"}}).then(res=>res.data);
    }

    deleteServicioGrupoEtapa(info){
        const url = process.env.VUE_APP_APIURL + `/api/serviciogrupoetapabaja`;     
        return axios.post(url,info,{headers:{"Content-Type" : "application/json"}}).then(res=>res.data);
    }

   

}